<asax-result-table-search-table-cell-popover
  [text]="(freqMin | number )?.concat('..')?.concat(freqMax | number)?.concat(' GHz')">
  <title *ngTemplateOutlet="frequencySupportTitle"></title>
  <content *ngTemplateOutlet="frequencySupportContent"></content>
</asax-result-table-search-table-cell-popover>

<ng-template #frequencySupportTitle>
  <i class="fa-light fa-bolt-lightning me-1"></i>Frequency Support
</ng-template>

<ng-template #frequencySupportContent>
  <ng-container *ngIf="!isLoading; else loading">
    <ngx-datatable class="result-table-popover material striped"
                   [style.max-height.vh]="50"
                   [style.width.px]="830"
                   [scrollbarH]="true"
                   [columnMode]="ColumnMode.standard"
                   [messages]="{emptyMessage: ''}"
                   [rowHeight]="'auto'"
                   [headerHeight]="40"
                   [footerHeight]="0"
                   [rows]="rows">
      <ngx-datatable-column name="Frequency" prop="frequency" [width]="160"></ngx-datatable-column>
      <ngx-datatable-column name="Resolution" prop="resMax" [width]="120"></ngx-datatable-column>
      <ngx-datatable-column name="Sensitivity 10Km/s" prop="sens10" [width]="180"></ngx-datatable-column>
      <ngx-datatable-column name="Sensitivity native" prop="sensBand" [width]="170"></ngx-datatable-column>
      <ngx-datatable-column name="Pol. Product" prop="polProduct" [width]="100"></ngx-datatable-column>
      <ngx-datatable-column name="Type" prop="chaNum" [width]="100">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>{{value | frequencyType}}</ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </ng-container>
</ng-template>

<ng-template #loading>
  <div class="d-flex justify-content-center">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-template>
